import React from 'react'

/* Components */
import Switching from './Switching';

/* Modules */
import html2canvas from 'html2canvas';

class SwitchingContainer extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            // champObject: props.champObject,
            // idOfSwitching: props.idOfSwitching,
            switchingList: [],

            roundOf16Competitors: [{ nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }, { nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }, { nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }, { nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }],
            quarterFinalsCompetitors: [{ nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }, { nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }],
            semiFinalsCompetitors: [{ nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }],
            finalCompetitors: [{ nome: '', colunaUm: true }, { nome: '', colunaUm: false }],

            /* Array to create divs that draws the line between switching */
            arrayForLines01: [1, 2, 3, 4],
            arrayForLines02: [1, 2],
            arrayForLines03: [1],
        }
    }

    componentDidMount = () => {
        // this.componentWillReceiveProps(this.props)

        /* Create array of switching list */
        let localArrayOfswitching = []
        for (let i = 0; i < 10; i++) {
            localArrayOfswitching.push(i)
        }
        this.setState({
            switchingList: localArrayOfswitching
        })

        /* Clear all confrontations */
        this.setState({
            roundOf16Competitors: [{ nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }, { nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }, { nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }, { nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }],
            quarterFinalsCompetitors: [{ nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }, { nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }],
            semiFinalsCompetitors: [{ nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }],
            finalCompetitors: [{ nome: '', colunaUm: true }, { nome: '', colunaUm: false }]
        })

        /* Get all confrontations and info */
        let switching = this.props.switching;

        /* Get confrontations */
        if (switching.roundOf16 !== undefined)
            this.setState({ roundOf16Competitors: switching.roundOf16 })
        if (switching.quarterFinals !== undefined)
            this.setState({ quarterFinalsCompetitors: switching.quarterFinals })
        if (switching.semiFinals !== undefined)
            this.setState({ semiFinalsCompetitors: switching.semiFinals })
        if (switching.final !== undefined) {
            this.setState({ finalCompetitors: switching.final })
            if (switching.final[0].hasWon && switching.final[0].hasWon !== undefined)
                this.setState({ champion: switching.final[0].nome })
            else if (!switching.final[0].hasWon && switching.final[0].hasWon !== undefined)
                this.setState({ champion: switching.final[1].nome })
        }

        /* Get teams with score */
        if (switching.arrayOfTeams !== undefined)
            this.setState({ arrayOfTeamsWithScore: switching.arrayOfTeams })

        /* Get info */
        this.setState({
            studentSexo: switching.sexo,
            studentFaixa: switching.faixa,
            studentPeso: switching.peso,
            studentIdade: switching.idade,
            switchingId: switching.__key
        });
    }
    // componentWillReceiveProps = (nextProps) => {
    //     console.log(nextProps)
    //     /* Open Loading Icon */
    //     if(document.getElementById('loadingSwitching') !== null)
    //         document.getElementById('loadingSwitching').style.display = 'block'

    //     /* Create array of switching list */
    //     let localArrayOfswitching = []
    //     for(let i = 0; i < 10; i++){
    //         localArrayOfswitching.push(i)
    //     }
    //     this.setState({
    //         switchingList: localArrayOfswitching
    //     })

    //     /* Clear all confrontations */
    //     this.setState({
    //         roundOf16Competitors: [{nome:'', colunaUm: true},{nome:'', colunaUm: true},{nome:'', colunaUm: false},{nome:'', colunaUm: false},{nome:'', colunaUm: true},{nome:'', colunaUm: true},{nome:'', colunaUm: false},{nome:'', colunaUm: false},{nome:'', colunaUm: true},{nome:'', colunaUm: true},{nome:'', colunaUm: false},{nome:'', colunaUm: false},{nome:'', colunaUm: true},{nome:'', colunaUm: true},{nome:'', colunaUm: false},{nome:'', colunaUm: false}],
    //         quarterFinalsCompetitors: [{nome:'', colunaUm: true},{nome:'', colunaUm: true},{nome:'', colunaUm: false},{nome:'', colunaUm: false},{nome:'', colunaUm: true},{nome:'', colunaUm: true},{nome:'', colunaUm: false},{nome:'', colunaUm: false}],
    //         semiFinalsCompetitors: [{nome:'', colunaUm: true},{nome:'', colunaUm: true},{nome:'', colunaUm: false},{nome:'', colunaUm: false}],
    //         finalCompetitors: [{nome:'', colunaUm: true},{nome:'', colunaUm: false}]
    //     })

    //     /* Firestore */
    //     /* Get all confrontations and info */
    //     if(nextProps.idOfSwitching !== undefined){
    //         /*firebase.firestore().collection('champs').doc(this.state.champObject.__key).collection('switching').doc(this.state.idOfSwitching.toString()).get()*/
    //         firebase.database().ref('champs/' + this.state.champObject.__key + '/switching/' + nextProps.idOfSwitching.toString()).once('value')
    //         .then(switching => {
    //             if(switching.val() !== undefined && switching.val() !== null){

    //                 /* Get confrontations */
    //                 if(switching.val().roundOf16 !== undefined)
    //                     this.setState({ roundOf16Competitors: switching.val().roundOf16 })
    //                 if(switching.val().quarterFinals !== undefined)
    //                     this.setState({ quarterFinalsCompetitors: switching.val().quarterFinals })
    //                 if(switching.val().semiFinals !== undefined)
    //                     this.setState({ semiFinalsCompetitors: switching.val().semiFinals })
    //                 if(switching.val().final !== undefined){
    //                     this.setState({ finalCompetitors: switching.val().final })
    //                     if(switching.val().final[0].hasWon && switching.val().final[0].hasWon !== undefined)
    //                         this.setState({ champion: switching.val().final[0].nome })
    //                     else if(!switching.val().final[0].hasWon && switching.val().final[0].hasWon !== undefined)
    //                         this.setState({ champion: switching.val().final[1].nome })
    //                 }

    //                 /* Get teams with score */
    //                 if(switching.val().arrayOfTeams !== undefined)
    //                     this.setState({ arrayOfTeamsWithScore: switching.val().arrayOfTeams })

    //                 /* Get info */
    //                 this.setState({
    //                     studentSexo: switching.val().sexo,
    //                     studentFaixa: switching.val().faixa,
    //                     studentPeso: switching.val().peso,
    //                     studentIdade: switching.val().idade
    //                 })
    //             }
    //         })
    //         .then(() => {
    //             /* Close Loading Icon */
    //             if(document.getElementById('loadingSwitching') !== null)
    //                 document.getElementById('loadingSwitching').style.display = 'none'
    //         })
    //     }
    // }

    renderPdf = () => {

        html2canvas(document.getElementById("printAreaOfSharedSwitching")).then(canvas => {
            // document.body.appendChild(canvas);
            var pri = document.getElementById("ifmcontentstoprint_shared_switching").contentWindow;
            pri.document.open();
            pri.document.appendChild(canvas);
            pri.document.close();
            pri.focus();
            pri.print();
        });
    }

    render() {

        return (
            <Switching
                roundOf16Competitors={this.state.roundOf16Competitors}
                arrayForLines01={this.state.arrayForLines01}
                quarterFinalsCompetitors={this.state.quarterFinalsCompetitors}
                arrayForLines02={this.state.arrayForLines02}
                semiFinalsCompetitors={this.state.semiFinalsCompetitors}
                arrayForLines03={this.state.arrayForLines03}
                finalCompetitors={this.state.finalCompetitors}

                studentSexo={this.state.studentSexo}
                studentFaixa={this.state.studentFaixa}
                studentPeso={this.state.studentPeso}
                studentIdade={this.state.studentIdade}
                switchingId={this.state.switchingId}

                renderPdf={() => this.renderPdf()}
            />
        )
    }
}

export default SwitchingContainer